import { css } from "@emotion/react";

import { translate } from "~utils";

type RequestCountProps = {
  page: "active" | "past";
  count: number;
};

export function RequestCount(props: RequestCountProps) {
  const { page, count } = props;
  return (
    <div className="mw-800">
      <p
        css={css`
          padding: 0 16px;

          @media (min-width: 900px) {
            padding-left: 0px;
          }
        `}
      >
        {translate(
          page === "active" ? "LABEL_ACTIVE_REQUESTS_COUNT" : "LABEL_PAST_REQUESTS_COUNT",
          { count: count },
        )}
      </p>
    </div>
  );
}
